import * as yup from "yup";
import AlertDialog from "../components/AlertDialog";

const StepFourContractInitialValues = {
  // projectExpectedCost:'',
  creatorInitialAmount:'',
  howMuchInvesting:'',
  howMuchInvestors:'',
  minimumInvestment:'',
  maximumInvestment:'',
  millstones: [
    {
      id: 0,
      description: "",
      deadLine: "",
      amount: ""
    }
  ],
  termAgreement: false,
  contractPath: '',
  bankDetails: {
    country: '',
    bankName: '',
    accountTitle: '',
    recipientName: '',
    recipientAddress: '',
    accountNumber: '',
    swiftCode: ''
  }
}

const StepFourContractSchema = yup.object().shape({
  // projectExpectedCost:  yup.string().required("projectExpectedCost  is required"),
  creatorInitialAmount:  yup.string().required("Creator Initial Amount is required"),
  howMuchInvesting:  yup.string().required("Investment Amount is required"),
  howMuchInvestors:  yup.string().required("Number of Investor(s) is required"),
  minimumInvestment:  yup.number("Investment should be a number").required("Minimum Investment is required"),
  maximumInvestment:  yup.number("Investment should be a number").required("Maximum Investment is required"),
  millstones: yup.array().of(
    yup.object().shape({
      description: yup.string().required("Milestones Description is required"),
      amount: yup.number().required("Milestones Amount is required"),
      deadLine: yup.string().required("Milestones Deadline is required")
    })
  ),
  contractPath:  yup.string(),
  termAgreement: yup.boolean()
  .required(<AlertDialog open={true} btn_Orange_Text={'GO BACK'} title={'You must agree to the terms of service'} message={'In order to move forward, you must confirm that you have read and agreed to the terms of service'}/>)
  .oneOf([true], <AlertDialog open={true} title={"You must agree to the terms of service"} message={"In order to move forward, you must confirm that you have read and agreed to the terms of service"} btn_Orange_Text={"GO BACK"}/>),
  bankDetails: yup.object().shape({
    country: yup.string().required("Country is Required"),
    bankName: yup.string().required("Bank Name is Required"),
    accountTitle: yup.string().required("Account Title is Required"),
    recipientName: yup.string().required("Recipient Name is Required"),
    recipientAddress: yup.string().required("Recipient Address is Required"),
    accountNumber: yup.string().required("Account Number is Required"),
    swiftCode: yup.string().required("Swift Code is Required").min(4,"A valid BIC must have minimum 4 digits").max(11, "A valid BIC must have maximum 11 digits"),
  })

});

const StepTwoTeamSchema = yup.object().shape({
  casts: yup.array().of(
    yup.object().shape({
      avatar: yup.string(),
      role: yup.string().required("Role is required"),
      character: yup.string().required("Character is required"),
      name: yup.string().required("name is required")
    })
  ),
  directors: yup.array().of(
    yup.object().shape({
      director: yup.string().required("director is required"),
    })
  ),
  producers: yup.array().of(
    yup.object().shape({
      producer: yup.string().required("producer is required"),
    })
  ),
  cinematographers: yup.array().of(
    yup.object().shape({
      cinematographer: yup.string().required("cinematographer is required"),
    })
  ),
})

const StepTwoTeamInitialValues = {
  casts: [{
    id: 0,
    avatar:'',
    role:'',
    character:'',
    Name:'',
  }],
  directors: [{
    id: 0,
    director:'',
  }],
  producers: [{
    id: 0,
    producer:'',
  }],
  cinematographers: [{
    id: 0,
    cinematographer:'',
  }],
}


const StepOneProjectDetailInitialValues = {
  genre: [],
  tags: [],
  rating: '',
  releaseDate: '',
  investmentDeadline:'',
  primaryFilmLocation: '',
  budget: '',
  synopsis: '',
  plot: '',
  title:'',
  description:'',
  mainCasts:[{
    id: 0,
    name: '',
    role: '',
    avatar: '',
    evidence:{}
  }]
}

const StepOneProjectDetailSchema = yup.object().shape({
  genre:  yup.array().required("Genre is Required"),
  tags:  yup.array().required("Tags  is Required"),
  rating:  yup.string().required("Rating is Required"),
  releaseDate:  yup.string().required("Release Date is Required"),
  title:  yup.string().required("Title is Required"),
  description:  yup.string()
  .min(300, 'Description should be of minimum 300 characters length')
  .max(500, 'Description should be of maximum 500 characters length')
  .required("Description is Required"),
  investmentDeadline:  yup.string().required("Investment Deadline is Required"),
  primaryFilmLocation:  yup.string().required("Primary Film Location is Required"),
  budget:  yup.number("Budget should be in Number").required("Budget is Required"),
  synopsis: yup.string()
  .min(300, 'Synopsis should be of minimum 300 characters length')
  .max(500, 'Synopsis should be of maximum 500 characters length')
  .required("Synopsis is Required"),
  plot: yup.string()
  .min(300, 'Plot should be of minimum 300 characters length')
  .max(500, 'Plot should be of maximum 500 characters length')
  .required("Plot is Required"),
  mainCasts: yup.array().of(
    yup.object().shape({
      avatar: yup.string(),
      name: yup.string().required("Name is Required"),
      role: yup.string().required("Role is Required")
    })
  ),
});


const ProjectSetup = {
  StepFourContractInitialValues,
  StepFourContractSchema,
  StepTwoTeamSchema,
  StepTwoTeamInitialValues,
  StepOneProjectDetailInitialValues,
  StepOneProjectDetailSchema
}
export default ProjectSetup;